import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { ISupplier } from 'types';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeSupplierPhone: (value: string) => void;
	supplierTaxpayerId: ISupplier['taxpayerId'];
	supplierName: ISupplier['name'];
}

export const SupplierPhoneNumberField: React.FC<IProps> = React.memo(
	({ changeSupplierPhone, supplierTaxpayerId, supplierName }) => {
		const { t } = useTranslation('error');

		const validationRules = useMemo<Rule[]>(
			() => [
				{ required: !!(supplierTaxpayerId || supplierName), message: t('enterPhoneNumber') },
				// () => ({
				// 	validator(_, value) {
				// 		if (!value || value.replace(/\s/g, '').length === 12) {
				// 			return Promise.resolve();
				// 		}
				// 		return Promise.reject(new Error(t('phoneShouldContainDigits', { value: '11' })));
				// 	},
				// }),
			],
			[t, supplierTaxpayerId, supplierName],
		);

		const handleChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				e.target.maxLength = 24;
				const withoutLetters = e.target.value.replace(/\D+$/g, '');
				// Regex below: https://stackoverflow.com/questions/70214348/phone-number-masking-without-plugin
				let validValue = withoutLetters
					.replace(/^(\d)/, '+7 $1')
					.replace(/(\+7\s\d{3})(\d)/, '$1 $2')
					.replace(/(\+7\s\d{3}\s\d{3})(\d)/, '$1 $2')
					.replace(/(\+7\s\d{3}\s\d{3}\s\d{2})(\d)/, '$1 $2')
					.replace(/(\+7\s\d{3}\s\d{3}\s\d{2}\s\d{2})(\d)/, '$1 $2')
					.replace(/(\+7\s\d{3}\s\d{3}\s\d{2}\s\d{2}\s\d{8})\d+?$/, '$1');

				if (validValue === '+7') {
					validValue = '';
					changeSupplierPhone('');
				} else if (validValue.length === 2 && validValue !== '+7') {
					validValue = '+7 ';
				}

				changeSupplierPhone(validValue);
				return validValue;
			},
			[changeSupplierPhone],
		);

		return (
			<FormInput
				testId="SupplierPhoneNumberField"
				name="supplierPhone"
				label="supplierPhoneNumberLabel"
				placeholder="0 000 000 00 00"
				getValueFromEvent={handleChange}
				validationRules={validationRules}
			/>
		);
	},
);
